/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, {Component} from 'react';
import Modal from 'react-modal';
import Iframe from 'react-iframe';
import AxiosClient from "../../../_helpers/http.helper";
import config from "../../../config";
import urlHelper from "../../../_helpers/url.format.server.helper";
import {TextInput} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import { Icon } from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import {PERMISSIONS} from "../../constants/constants";


export default class CoverTitle extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: false,
            coverImageUrl: '',
            titlePageDetails: { titlePage: {
                title: '',
                subTitle:'',
                authorName:'',
                content:''
            }}
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.cancelModal =this.cancelModal.bind(this);
    }

    componentDidMount() {
        this.props.guardDirtySetActive(false);

        if (typeof this.props.setComponent === 'function') {
            this.props.setComponent("CoverTitle");
        }

        this.getCoverPageImage();

        this.getCoverPageDetails();

        window.sessionStorage.setItem("login", config.instructorPortal.loginToken);

    }

    getCoverPageImage() {

        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.getFrontCover,
            {
                collectionId: this.props.match.params.collId
            }
        );

        AxiosClient.get(url)
            .then(response => {

                this.setState({
                    coverImageUrl: response.data.coverPageUrl,
                });

            })
            .catch(error => {
                console.log("Error ", error);
            });
    }

    getCoverPageDetails() {

        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.titlePageInfo,
            {
                collectionId: this.props.match.params.collId
            }
        );

        AxiosClient.get(url)
            .then(response => {

                this.setState({
                    titlePageDetails: response.data,
                });

                this.props.options.setCoverAndTitlePageState(response.data);
            })
            .catch(error => {
                console.log("Error ", error);
            });
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.setState({modalIsOpen: false});
        this.getCoverPageImage();
        this.props.loadInitialData(this.props.match.params.collId);
    }

    cancelModal(){
        this.setState({modalIsOpen: false});
        this.props.loadInitialData(this.props.match.params.collId); 
    }

    removeHeaderInIfram() {

        let frame = document.getElementById("myId");
        if(frame.contentDocument){
            let pearsonHeader = frame.contentDocument.getElementsByTagName("header")[0];
            pearsonHeader.style.display = "none";

            let mainWrapper = frame.contentDocument.getElementById("main-wrapper");
            mainWrapper.style.top = "0px";
        }
    }

    changeBookTitleState = (event) => {

        let coverAndTitleDetails = {...this.state.titlePageDetails};
        coverAndTitleDetails.titlePage.title = event.target.value;

        this.setState({
            titlePageDetails: coverAndTitleDetails
        });

        this.props.options.changeBookTitle(event.target.value);
        this.props.guardDirtySetActive(true);
    };

    changeBookSubTitleState = (event) => {

        let coverAndTitleDetails = {...this.state.titlePageDetails};
        coverAndTitleDetails.titlePage.subTitle = event.target.value;

        this.setState({
            titlePageDetails: coverAndTitleDetails
        });

        this.props.options.changeBookSubtitle(event.target.value);
        this.props.guardDirtySetActive(true);
    };

    changeBookAuthorState = (event) => {

        let coverAndTitleDetails = {...this.state.titlePageDetails};
        coverAndTitleDetails.titlePage.authorName = event.target.value;

        this.setState({
            titlePageDetails: coverAndTitleDetails
        });

        this.props.options.changeBookAuthor(event.target.value);
        this.props.guardDirtySetActive(true);
    };

    changeBookOtherState = (event) => {

        let coverAndTitleDetails = {...this.state.titlePageDetails};
        coverAndTitleDetails.titlePage.content = event.target.value;

        this.setState({
            titlePageDetails: coverAndTitleDetails
        });

        this.props.options.changeBookOther(event.target.value);
        this.props.guardDirtySetActive(true);
    };

    render() {

        const collectionId = this.props.collection.collectionId;
        const iFramUrl = urlHelper.formatUrl(
            config.instructorPortal.baseUrl,
            config.instructorPortal.routes.getCoverAndTitlePage,
            {
                collectionId: collectionId
            }
        );

        return (

            <div className="modal-dialog-widget">

                <div className="title-field">

                    <h4>Title page text</h4>
                    <div className="pe-form--group">
                        <TextInput id="coverTitle" labelText="Title"
                            placeholder="Enter Title"
                            value ={this.state.titlePageDetails.titlePage && this.state.titlePageDetails.titlePage.title}
                            changeHandler={this.changeBookTitleState}
                            inputState={this.props.permissions.includes(PERMISSIONS.view_only_cover_title)? 'disabled' : ''}/>
                    </div>
                    <div className="pe-form--group text-field">
                        <TextInput id="coverSubtitle" labelText="Subtitle"
                            placeholder="Enter Subtitle"
                            value ={this.state.titlePageDetails.titlePage && this.state.titlePageDetails.titlePage.subTitle}
                            changeHandler={this.changeBookSubTitleState}
                            inputState={this.props.permissions.includes(PERMISSIONS.view_only_cover_subtitle)? 'disabled' : ''}/>
                    </div>
                    <div className="pe-form--group text-field">
                        <TextInput id="coverAuthor" labelText="Author"
                            placeholder="Enter Author"
                            value ={this.state.titlePageDetails.titlePage && this.state.titlePageDetails.titlePage.authorName}
                            changeHandler={this.changeBookAuthorState}
                            inputState={this.props.permissions.includes(PERMISSIONS.view_only_cover_author)? 'disabled' : ''}/>
                    </div>
                    <div className="pe-form--group text-field">
                        <TextInput id="coverOther"  labelText="Other"
                            placeholder="Enter Other"
                            value ={this.state.titlePageDetails.titlePage && this.state.titlePageDetails.titlePage.content}
                            changeHandler={this.changeBookOtherState}
                            inputState={this.props.permissions.includes(PERMISSIONS.view_only_cover_other)? 'disabled' : ''}/>
                    </div>
                </div>

                <div className="cover-page-edit">
                    <h4>Cover Design</h4>
                    <span>Click to edit cover page</span>

                    <div>
                        {this.props.permissions.includes(PERMISSIONS.view_only_cover_design)?  
                            (this.state.coverImageUrl === '' || !this.state.coverImageUrl)?
                                <div className="cover-image-empty">No image</div>
                                :
                                <img className="cover-image-thumbnail view_thumbnail" src={this.state.coverImageUrl}/>
                            :
                            (this.state.coverImageUrl === '' || !this.state.coverImageUrl)?
                                <div className="cover-image-empty" onClick={this.openModal}>No image</div>
                                :
                                <img className="cover-image-thumbnail" src={this.state.coverImageUrl} onClick={this.openModal}/>
                        }
                    </div>
                    <Modal
                        className="modal-content-cover"
                        overlayClassName="modal-overlay-cover"
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={this.closeModal}
                        contentLabel="coverPage"
                        closeTimeoutMS={150}
                    >
                        <div className="modal-header-cover">
                            <div className="modal-close-button modal-close" onClick={this.closeModal}>
                                <Icon name='remove-lg-18'/>
                            </div>
                        </div>

                        <div className="cover-page-modal-body">
                            <Iframe url={iFramUrl}
                                width="99%" height="100%" id="myId"
                                className="myClassname" display="initial" position="relative" onLoad={this.removeHeaderInIfram}/>
                        </div>

                        <div className="modal-footer-cover">
                            <button className="pe-btn--btn_large btn-cancel" onClick={this.cancelModal}>Cancel</button>
                            <button className='pe-btn__primary--btn_large btn-action' onClick={this.closeModal}>Done</button>
                        </div>
                    </Modal>
                </div>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/CoverTitle.js